"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.About = void 0;
const about_1 = require("@geome/react-components-next/lib/components/about");
const react_1 = __importDefault(require("react"));
const react_next_1 = require("@geome/react-next");
const About = ({ location }) => {
    const showAbout = (0, react_next_1.useConfig)("station_page.sections.about.show", true);
    if (!(showAbout !== null && showAbout !== void 0 ? showAbout : showAbout === false) || !location.description)
        return null;
    return (react_1.default.createElement(about_1.About, { sectionName: "about", configPath: "station_page.", locationName: location.name, text: location.description }));
};
exports.About = About;
